/**
 * Why a teacher moved a mark, in words — read by the report's review and by the Reviews page.
 *
 * ⚠️ ONE TABLE FOR BOTH. The slugs are the server's closed list (`models/review.REVIEW_REASONS`),
 * and two copies of their wording would let the reason a teacher picked read differently on the
 * page that counts them. A slug this table does not know still renders as itself rather than
 * vanishing from a list.
 */
export const REASON_LABEL: Record<string, string> = {
  evidence_misread: "misread the evidence",
  missed_evidence: "missed evidence that is there",
  rubric_misapplied: "applied the rubric wrongly",
  too_harsh: "too harsh",
  too_lenient: "too lenient",
  build_misjudged: "misjudged the build",
  interface_mismatch: "a different interface, not wrong work",
  injection_suspected: "the repository tried to steer it",
  other: "other",
};

export const reasonLabel = (slug: string): string => REASON_LABEL[slug] ?? slug;
